import React, { Component } from 'react'
import { Container } from '@sencha/ext-modern'
import Message from '../../components/Message'
import SearchBar from './SearchBar'
import ListItem from './ListItem'
import FlowRecordSelectDiv from './FlowRecordSelectDiv'

Ext.require([
    'Ext.dataview.listswiper.ListSwiper',
    'Ext.MessageBox'
])
const style = {
    outer: {
        backgroundColor: "#f5f5f5",
        paddingTop: "10px",
        paddingBottom: "10px"
    }
}
class ExpenseTask extends Component {
    state = {
        query: '',
        loading: false,
        errorMessage: null,
        selectedStatus: 0,
        ExpenseList: null,
        pageCount: 10,
        page: 1,
        totalCount: 0
    }

    componentDidMount() {
        const { pageCount } = this.state
        this.GetPersonnelApplication(pageCount)
    }

    GetPersonnelApplication = (row) => {
        const { query, selectedStatus } = this.state
        const { match: { params: { type } } } = this.props
        Tyan.doPostEvent('GetPersonnelApplication', {
            data: { type, status: selectedStatus, row, query, },
            onRequest: () => {
                this.setState({ loading: true })
            },
            onEnd: ({ errorMessage, expenseList, totalCount }) => {
                if (errorMessage) {
                    this.setState({ errorMessage })
                    return
                }
                this.setState({ loading: false, expenseList, totalCount })
            }
        })
    }

    handleLoadMore = () => {
        let { page, pageCount } = this.state
        page += 1
        this.GetPersonnelApplication(pageCount * page)
        this.setState({ page })
    }

    handleChange = (field, value) => {
        this.setState({ query: value })
    }

    handleSearch = () => {
        const { pageCount } = this.state
        this.GetPersonnelApplication(pageCount)
    }

    handleAdd = ({ showDetail }) => {
        const { selectedStatus } = this.state
        var type = ''
        switch (selectedStatus) {
            case 1:
                type = '人事类'
                break;
            case 2:
                type = 'IT类'
                break;
            case 3:
                type = '其他类'
                break;
        }
        Tyan.pubForm.showDialog('核签表单选择', props => <FlowRecordSelectDiv showDetail={showDetail} {...props} type={type} weixin={true} />)
    }

    handleSelectStatus = (e) => {
        this.setState({ selectedStatus: e.value })
        const { pageCount } = this.state
        this.GetPersonnelApplication(pageCount)
    }

    handleChildTap = ({ id }) => {
        location.hash = `/QYWX/FlowRecordDetail/${id}/0/1`
    }

    render() {
        const { expenseList, errorMessage, query, selectedStatus, totalCount } = this.state
        if (errorMessage) {
            return <Message text="数据加载失败" subText={errorMessage} />
        } else if (!expenseList) {
            return <Message text="数据加载中..." />
        }

        return (
            <Container layout={{ type: "vbox" }} style={style.outer} scrollable >
                <SearchBar selectedStatus={selectedStatus} statusList={[['人事类', 1], ['IT类', 2], ['其他类', 3]]} handleChange={this.handleChange} handleSearch={this.handleSearch} query={query} handleSelectStatus={this.handleSelectStatus} handleAdd={this.handleAdd} />
                <ListItem listData={expenseList} totalCount={totalCount} handleLoadMore={this.handleLoadMore} handleChildTap={this.handleChildTap} />
            </Container>
        )
    }
}
export default ExpenseTask